import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ErrorHandlingService } from '../../error-handling/error-handling.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SpinnerService } from '../../spinner';
import { Observable, of } from 'rxjs';
import { HttpHeaderConstants } from '../../http-header.constant';
import { catchError, finalize } from 'rxjs/operators';
import { ResponsysAppDetail } from '../../../models/appcloud/responsys-detail.model';

/**
 * @deprecated
 */
@Injectable({
    providedIn: 'root',
})
export class ResponsysAppDetailService {
    readonly #errorHandlingService = inject(ErrorHandlingService);
    readonly #http = inject(HttpClient);
    readonly #spinnerService = inject(SpinnerService);

    private RESPONSYS_APP_DETAILS_URL: string = environment.publicApiHost + '/appcloud/responsys-app-details';

    getByAppId(appId: number, additionalHeaders: any = {}): Observable<ResponsysAppDetail[]> {
        this.#spinnerService.addProcess('ResponsysAppDetailService.getByAppId', 'Loading Responsys app details...');
        const httpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders, ...additionalHeaders }),
            params: new HttpParams().set('appId', appId.toString()),
        };

        return this.#http.get<ResponsysAppDetail[]>(this.RESPONSYS_APP_DETAILS_URL, httpOptions).pipe(
            catchError(error => {
                this.#errorHandlingService.handleHttpError(
                    error,
                    false,
                    'An error occurred while retrieving Responsys app data from Relationship One. Please try again later.'
                );
                return of<ResponsysAppDetail[]>();
            }),
            finalize(() => this.#spinnerService.completeProcess('ResponsysAppDetailService.getByAppId'))
        );
    }

    create(responsysAppDetail: ResponsysAppDetail, additionalHeaders: any = {}): Observable<ResponsysAppDetail> {
        this.#spinnerService.addProcess('ResponsysAppDetailService.create', 'Creating Responsys app details...');
        const httpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders, ...additionalHeaders }),
        };

        return this.#http
            .post<ResponsysAppDetail>(this.RESPONSYS_APP_DETAILS_URL, responsysAppDetail, httpOptions)
            .pipe(
                catchError(error => {
                    this.#errorHandlingService.handleHttpError(
                        error,
                        false,
                        'An error occurred while creating Responsys app details. Please try again later.'
                    );
                    return of<ResponsysAppDetail>();
                }),
                finalize(() => this.#spinnerService.completeProcess('ResponsysAppDetailService.create'))
            );
    }

    update(
        id: number,
        responsysAppDetail: ResponsysAppDetail,
        additionalHeaders: any = {}
    ): Observable<ResponsysAppDetail> {
        this.#spinnerService.addProcess('ResponsysAppDetailService.update', 'Updating Responsys app details...');
        const httpOptions = {
            headers: new HttpHeaders({
                ...HttpHeaderConstants.mergePatch,
                ...additionalHeaders,
            }),
        };

        return this.#http
            .patch<ResponsysAppDetail>(this.RESPONSYS_APP_DETAILS_URL + '/' + id, responsysAppDetail, httpOptions)
            .pipe(
                catchError(error => {
                    this.#errorHandlingService.handleHttpError(
                        error,
                        false,
                        'An error occurred while updating Responsys app details. Please try again later.'
                    );
                    return of<ResponsysAppDetail>();
                }),
                finalize(() => this.#spinnerService.completeProcess('ResponsysAppDetailService.update'))
            );
    }
}
